var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.958496H513V342.951H0V0.958496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.247 171.956L0 57.6582V286.274L114.247 171.956Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.507 171.955L0 10.3398V57.6581L114.247 171.956L0 286.274V333.504L161.507 171.955Z",
    fill: "#FFB915"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.829 205.411C510.887 204.97 511.634 204.531 513 204.09V138.499H223.037L85.4967 0.958496H0V10.3398L161.507 171.955L0 333.504V342.951H85.4967L223.037 205.411H510.829Z",
    fill: "#007847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.163 238.868H236.894L132.811 342.951H513V238.868H504.163Z",
    fill: "#000C8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.163 105.041H513V0.958496H132.811L236.894 105.041H504.163Z",
    fill: "#E1392D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.95459)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZa);
export default __webpack_public_path__ + "static/media/ZA.d4f85dfd162a42ef49708ddbe9d39240.svg";
export { ForwardRef as ReactComponent };